import checkoutFormModel from './checkoutFormModel';

const {
  formField: {
    resource,
    vehicleType,
    domain,
    propertyNumber,
    firstname,
    lastname,
    document,
    areaPhone,
    phoneNumber,
    areaCellPhone,
    cellPhoneNumber,
    email,
    emailConfirmation,
    debitType,
    cardBrand,
    cardNumber,
    cardExpireFrom,
    cardExpireTo,
    cbu,
    cbuConfirmation
  }
} = checkoutFormModel;

const formInitialValues = {
  [resource.name]: '',
  [vehicleType.name]: '',
  [domain.name]: '',
  [propertyNumber.name]: '',
  [firstname.name]: '',
  [lastname.name]: '',
  [document.name]: '',
  [areaPhone.name]: '',
  [phoneNumber.name]: '',
  [areaCellPhone.name]: '',
  [cellPhoneNumber.name]: '',
  [email.name]: '',
  [emailConfirmation.name]: '',
  [debitType.name]: '',
  [cardBrand.name]: '',
  [cardNumber.name]: '',
  [cardExpireFrom.name]: '',
  [cardExpireTo.name]: '',
  [cbu.name]: '',
  [cbuConfirmation.name]: '',
};

export default formInitialValues;